import React, { Component } from 'react';
import Select from 'react-select';
import { AddRevenue } from '../../Redux/action/revenueAction';
import {
  allLocationWithShortName,
  dataLocation,
  dataUser,
  spocLocationDetailsZoho,
} from '../Helpers/util';
import './form.css';
import moment, { duration } from 'moment';
import axios from 'axios';
import { getLocationNameById } from '../../utils/getLocationNameById';
import SwInput from '../Common/FormComponent/SwInput';
import SwTextArea from '../Common/FormComponent/SwTextArea';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import { toast } from 'react-toastify';
const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const userDataLocal1 = dataLocation();
var LocationObj = JSON.parse(userDataLocal1);
const userDataLocal12 = spocLocationDetailsZoho();
const locationWithShortName = allLocationWithShortName()

class CracheCareServiceRequest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company_id: UserObj ? UserObj.company_id : null,
      spocid: UserObj ? UserObj.rec_id : null,
      email: UserObj ? UserObj.email : '',
      notes: '',
      locationSpoc: [],
      location: '',
      location1: '',
      locationError: '',
      notesError: '',
      locationData: [],
      locationNew: [],
      locationId: null,
      noOfUsers: '',
      duration: null,
      serviceTiming: null,
      durationError: '',
      noOfUsersError: '',
      serviceTimingError: '',
      files: null,
      attachmentError: '',
      btnStatus: false,
      selectedFile: undefined,
      selectedFileName: undefined,
      imageSrc: undefined,
      value: ''
    };
  }

  componentDidMount() {
    var LocationSpoc = JSON.parse(userDataLocal12);
    let locationShort = JSON.parse(locationWithShortName)
    this.setState({ locationNew: locationShort })
    this.setState({
      locationData: LocationSpoc,
    });
  }

  changeSelect = (e) => {
    if (!e) {
      this.setState({
        location: null,
        location1: "",
        locationId: "",
        locationError: "",
      });
      return;
    }

    this.setState({
      location: e,
      location1: String(e.label),
      locationId: e.value,
      locationError: "",
    });
  };


  options1 = [
    { value: '1 Months', label: '1 Month' },
    { value: '3 Months', label: '3 Months' },
    { value: '6 Months', label: '6 Months' },
    { value: '12 Months', label: '12 Months' },
  ];
  options2 = [
    { value: 'Half Day', label: 'Half-Day' },
    { value: 'Full Day', label: 'Full-Day' },
  ];



  onNotes = e => {
    this.setState({
      notes: e?.target?.value,
      notesError: '',
    });
  };

  resetValue = () => {
    this.setState({
      location: '',
      notes: '',
      locationError: '',
      notesError: '',
      noOfUsers: '',
      noOfUsersError: '',
      durationError: '',
      duration: '',
      serviceTiming: '',
      serviceTimingError: '',
      attachmentError: '',
    });
    this.setState({
      selectedFile: undefined,
      selectedFileName: undefined,
      imageSrc: undefined,
      value: ''
    })
  };

  onLocation = e => {
    this.setState({
      location: e?.target?.value,
      location1: String(e.value),
      locationError: '',
    });
  };
  handleDuration = (selectedOption) => {
    this.setState({ duration: selectedOption, durationError: '' });
  };

  handleServiceTiming = (selectedOption) => {
    this.setState({ serviceTiming: selectedOption, serviceTimingError: '' });
  };



  handleFile(e) {

    if (e.target.files[0]) {
      this.setState({
        selectedFile: e.target.files[0],
        selectedFileName: e.target.files[0].name,
        imageSrc: window.URL.createObjectURL(e.target.files[0]),
        value: e.target.value,
      });
    }

    this.setState({ files: e.target.files });

    if (e.target.files.length > 2) {
      this.setState({ attachmentError: "Attachment can't be more than 2" });
    }
    else if (e.target.files.length <= 2) {
      this.setState({ attachmentError: "" });
    }
  }




  onFormSubmit1 = e => {
    e.preventDefault();
    const { noOfUsers, duration, serviceTiming } = this.state;
    const localData = JSON.parse(localStorage.getItem('headData'));
    let files = this.state.files;
    let formData = new FormData();
    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        formData.append('file', files[i]);
      }
    }

    this.setState({
      locationError: '',
      noOfUsersError: '',
      durationError: '',
      serviceTimingError: ''
    });
    let hasError = false;
    if (this.state.location === null || this.state.location === '') {
      this.setState({ locationError: "Location can't be empty" });

    } else if (!noOfUsers) {
      this.setState({ noOfUsersError: "No Of Users can't be empty" });
    }
    else if (!duration) {
      this.setState({ durationError: "Duration Can't be Empty" });
    }
    else if (!serviceTiming) {
      this.setState({ serviceTimingError: " Service Timing Can't be empty" });
    }


    else if (this.state.files != null && this.state.files.length > 2) {
      this.setState({ attachmentError: "Attachment can't be more than 2" });
    } else {
      e.currentTarget.disabled = true
      let param = {};
      let common_param = {
        company_id: this.state.company_id,
        spoc_id: this.state.spocid,
        email: this.state.email,
        company_name: UserObj.company_name,
        category: 'creche_care',
      };
      let body_param = {
        location_name: this.state.location1,
        no_of_users: noOfUsers,
        duration: duration.value,
        service_timing: serviceTiming.value,
        notes: this.state.notes,
      };




      param.common_param = common_param;
      param.body_param = body_param;

      // AddRevenue(param, formData);
      // this.setState({
      //   btnStatus: false,
      // });
      // e.currentTarget.disabled = false
      AddRevenue(param, (success, message) => {
        if (success) {
          toast.success(message);
          this.resetValue();
          if (this.props.onClose) {
            this.props.onClose();
          }
        }
        this.setState({ btnStatus: false });
        e.currentTarget.disabled = false;
      });
    }
  };
  render() {

    const selectLocationData = [];
    if (this.state.locationSpoc && this.state.locationSpoc.length > 0) {
      this.state.locationSpoc.map(item => {
        if (item.rec_id) {
          selectLocationData.push({
            value: item['location_name_zoho'],
            label: item['location_name_zoho'],
          });
        }
        // selectLocationIds.push(JSON.stringify(item['rec_id']))
      });
    }
    return (
      <>

        <div className="row">
          {' '}
          <div className="col-md-12">
            <div className="SwFormGroup">
              {' '}
              <label className='SwFormLabel'>Location <span className="Required">*</span></label>{' '}
              <SwSelect
                name="location"
                id="crache-care-location-select"
                onChange={this.changeSelect}
                value={this.state.location}
                options={this.state.locationData}
                isClearable={false}
              />
              <span className="SwTextDanger SwTextSmall">
                {this.state.locationError}
              </span>
            </div>
          </div>{' '}
        </div>
        <div className='row'>
          <div className="col-md-12">
            {' '}
            <div className="SwFormGroup">
              <label className='SwFormLabel'>No of users <span className="Required">*</span></label>{' '}
              <SwInput
                type="number"
                id="crache-care-users"
                min="0"
                value={this.state.noOfUsers}
                onChange={(e) => this.setState({ noOfUsers: e.target.value, noOfUsersError: '' })}
              />{' '}
              <span className="SwTextDanger SwTextSmall">
                {this.state.noOfUsersError}
              </span>
            </div>
          </div > {' '}
        </div >
        <div className='row'>
          <div className="col-md-6">
            <div className="SwFormGroup">
              {' '}
              <label className='SwFormLabel'>Duration <span className="Required">*</span></label>{' '}
              <SwSelect
                placeholder="Select"
                id="crache-care-duration"
                options={this.options1}
                value={this.state.duration}
                onChange={this.handleDuration}
              />{' '}
              <span className="SwTextDanger SwTextSmall">
                {this.state.durationError}
              </span>
            </div>
          </div > {' '}
          < div className="col-md-6 pr-2" >
            <div className="SwFormGroup">
              {' '}
              <label className='SwFormLabel'>Service Timing <span className="Required">*</span></label>{' '}
              <SwSelect
                placeholder="Select"
                id="crache-care-service"
                options={this.options2}
                value={this.state.serviceTiming}
                onChange={this.handleServiceTiming}
              />{' '}
              <span className="SwTextDanger SwTextSmall">
                {this.state.serviceTimingError}
              </span>
            </div>
          </div > {' '}
        </div >
        <div className="row">
          <div className="col-md-12">
            <div className="SwFormGroup">
              {' '}
              <label className='SwFormLabel'>Notes</label>{' '}
              <SwTextArea
                id="crache-care-notes"
                rows="4"
                value={this.state.notes}
                onChange={this.onNotes}
              />{' '}
              <span className="SwTextDanger SwTextSmall">
                {this.state.notesError}
              </span>
            </div>
          </div > {' '}
        </div >
      </>
    );
  }
}

export default CracheCareServiceRequest;
